<template>
  <div class="bg-trader-gray p-2 text-center w-full flex flex-col gap-2">


    <span class="block w-full  h-6 p-2 ">
      Seiten Template ändern:
    </span>


    <div class="flex">
      <span class="inline-block min-w-[120px]   p-1">Template Gruppe</span>
      <select class="w-2/3 p-1 border border-bg-trader-input-border border-header flex-grow"
              data-ui="pageTemplateGroups"
              v-model="articleTemplateGroupId" @change="getPageTemplates">
        <option v-for="pageTemplateGroup in pageTemplateGroups"
                :key="pageTemplateGroup.idPageTemplateGroup"
                :value="pageTemplateGroup.idPageTemplateGroup">{{ pageTemplateGroup.name }}
        </option>
      </select>
    </div>

    <div class="overflow-auto max-h-[300px] grid grid-cols-3 gap-2">

      <div v-for="(pageTemplate,idx) in pageTemplates" :key="pageTemplate.pageTemplateId"
           class="hover:bg-trader-blue  hover:text-white flex flex-col items-center justify-center"
           @click="getTemplateId(pageTemplate.pageTemplateId)" :data-ui="'pageTemplate'+ pageTemplate.name"
           :class="{ 'bg-trader-green': selectedTemplateId == pageTemplate.pageTemplateId,
                      'bg-white': selectedTemplateId != pageTemplate.pageTemplateId }">

        <object :ref="idx" type="image/svg+xml" class="w-full h-[140px] p-2 pointer-events-none" :style="objectStyles?.[idx]"
                :data="'/api/v3/preview/grid/'+ pageTemplate.pageTemplateId + '?callback=' + createCallback(idx) +'&showNumbers=false'">
          <param name="type" value="image/svg+xml">
        </object>
        <p class="break-all w-full px-1">{{ pageTemplate.name }}</p>
      </div>

    </div>
    <div v-if="isLoading">
      <Spinner></Spinner>
    </div>
    <button class=" bg-white p-1 w-full" data-ui="changePageTemplate" @click="changePageTemplate()">Template
      Speichern
    </button>
  </div>
</template>

<script>
import apolloClient from "@/apolloClient";
import {gql} from "@apollo/client/core";
import SignalBus from "@/application/SignalBus";
import {eventBus} from "@/application/EventBus";
import SuccessConfirmation from "@/components/Dialogs/SuccessConfirmation.vue";
import Spinner from "@/components/Base/Spinner.vue";
import PageGrid from "@/components/PageGrid/PageGrid.vue";
import CompareTempates from "@/components/Dialogs/CompareTempates.vue";

export default {
  name: "CChangePageTemplate",
  components: {PageGrid, Spinner},
  props: {
    pageId: {
      type: Number,
      required: true,
    },
    pages: {
      type: Array,
      required: true,
    },
    showMarket: {
      type: Boolean,
      required: true,
    },
    marketIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      articleTemplateGroupId: 0,
      pageTemplates: [],
      pageTemplateGroups: [],
      pageIds: [],
      pageTemplateId: 0,
      selectedTemplateId: 0,
      magazineId: 0,
      isLoading: false,
      objectStyles: [],
    }
  },
  methods: {
    createCallback(index) {
      window.crossApi.callbacks['template' + index] = (w, h) => {
        this.objectStyles[index] = {
          width: w + 'px',
          height: h + 'px',
        };
      };
      return 'template' + index;
    },
    getTemplateId(id) {
      this.selectedTemplateId = id;
      this.pageTemplateId = id;
    },
    changePageTemplate() {
      SignalBus.emit("Headline-Template");
      if (this.pageTemplateId === 0) {
        eventBus.openModal(SuccessConfirmation);
        eventBus.setData({
          title: "Template nicht ausgewählt",
          message: "Bitte wählen Sie ein Template aus.",
        });
      } else {
        this.editPageTemplate()
      }
    },
    /*
    getMarketIds(marketIds, pageIds) {
      this.marketIds = marketIds;
      this.pageIds = pageIds;
    },*/
    async editPageTemplate() {

      this.isLoading = true;


      let marketIds = [];

      //for each this.marketIds item push it to marketIds only if it is not already in marketIds and not null or undefined
      this.marketIds.forEach(marketId => {
        if (!marketIds.includes(marketId) && marketId !== null && marketId !== undefined) {
          marketIds.push(marketId);
        }
      });

      // open modal
      console.log("marketIds", marketIds);
      if (marketIds.length <= 1) {
        eventBus.openModal(CompareTempates);
        eventBus.setData({
          title: "Template ändern",
          message: "Bitte zuerst das Raster anpassen, bevor Artikel getauscht werden. Beim Anpassen des Rasters werden die Artikel neu angeordnet – je nachdem, ob etwas zusammengeführt oder aufgeteilt wird.",
          pageTemplateId: this.pageTemplateId,
          pageId: this.pageId,
        });
      }else{
        const mutation = gql`
        mutation editPageTemplate($pageTemplateId: Int!, $magazineId: Int! , $marketIds: [Int!]!, $pageId: Int!) {
          editPageTemplate(pageTemplateId: $pageTemplateId, magazineId: $magazineId, marketIds: $marketIds, pageId: $pageId) {
            success
          }
        }
      `;
        try {
          const variables = {
            pageTemplateId: this.pageTemplateId,
            magazineId: this.magazineId,
            marketIds: marketIds,
            pageId: this.pageId
          };
          const {data} = await apolloClient.mutate({mutation, variables});
          if (data.editPageTemplate.success) {
            eventBus.openModal(SuccessConfirmation);
            eventBus.setData({
              title: "Template geändert",
              message: "Das Template wurde geändert.",
            });
          }
          SignalBus.emit("project-reload-purchaser-page");
          await this.getPages();
          await this.getShoppingSectionsFromPage();
        } catch (error) {
          console.error(error);
        } finally {
          this.isLoading = false;
        }
      }

      this.isLoading = false

    },
    async getPageTemplates() {
      try {
        const response = await apolloClient.query({
          query: gql`
        query getPageTemplates($articleTemplateGroupId: Int!) {
          getPageTemplates( articleTemplateGroupId: $articleTemplateGroupId) {
            pageTemplateId
            name

          }
        }
      `,
          variables: {
            articleTemplateGroupId: this.articleTemplateGroupId
          }
        });
        this.pageTemplates = response.data.getPageTemplates
        this.pageTemplates.forEach(pageTemplate => {
          if (pageTemplate.pageTemplateId === this.templateId) {
            this.selectedTemplateId = pageTemplate.pageTemplateId
          }
        });
      } catch (error) {
        console.error("Fehler beim Abrufen der pageTemplates:", error);
      }
    },
    async getPageTemplateGroups() {

      const response = await apolloClient.query({
        query: gql`
        query getPageTemplateGroups($magazinId: Int!) {
          getPageTemplateGroups(magazinId: $magazinId) {
            idPageTemplateGroup
            name
          }
        }
      `,
        variables: {
          magazinId: this.magazineId
        }
      });

      try {
        this.pageTemplateGroups = response.data.getPageTemplateGroups
      } catch (error) {
        console.error("Fehler beim Abrufen der pageTemplateGroups:", error);

      }
    },
  },
  mounted() {
    this.magazineId = this.$route.params.magazineId;
    this.getPageTemplateGroups()
    SignalBus.connect(this, "delete-purchaser-template", this.editPageTemplate);
  },
  beforeUnmount() {
    SignalBus.disconnectAllFromParent(this);
  },
  created() {
    this.magazineId = this.$route.params.magazineId;
  },
  watch: {
    '$route.params': {
      handler: function (params) {
        this.magazineId = params.magazineId;
      },
    }
  },
}
</script>